import { library } from '@fortawesome/fontawesome-svg-core'
import { faAlignLeft, faBook, faCalculator, faHandSparkles, faMagnifyingGlassChart, faScroll, faTools, faUserSecret } from '@fortawesome/free-solid-svg-icons';

library.add(
  faScroll, faTools, faUserSecret,
  faHandSparkles, faAlignLeft, faMagnifyingGlassChart,
  faCalculator, faBook,
);